export const REQUEST_ACTION_ADD = 'Add'
